import {
    ROOT,
    GET_ALL_LANDMARK,
    GET_ALL_AREA,
    CREATE_AREA,
    UPDATE_AREA,
    DELETE_AREA,
    GET_ALL_NEARBY
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";

function getLandmark() {
    return fetch(ROOT + GET_ALL_LANDMARK, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function getArea() {
    return fetch(ROOT + GET_ALL_AREA, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function create(data) {
    return fetch(ROOT + CREATE_AREA, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function update(data) {
    return fetch(ROOT + UPDATE_AREA, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function remove(data) {
    return fetch(ROOT + DELETE_AREA, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function getNearBy(landmarkId, keyword) {
    let data = {
        keyword: keyword,
        limit: 5,
        offset: 0
    }
    return fetch(ROOT + GET_ALL_NEARBY + "/" + landmarkId, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

export const service = {
    getLandmark,
    getArea,
    create,
    update,
    remove,
    getNearBy
};